import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';

import { attachmentsListOrigins } from '../../domains/attachments/constants';
import { ApiRequestDescriptor } from '../../services';

const CONTROL_ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/control-attachments`;
const MYACCOUNT_ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/myaccount-attachments`;

export interface ListFilesAttachmentRequestArgs {
  fileId: string;
  type?: string;
}

export const listFilesAttachmentRequest = ({
  fileId,
  type,
}: ListFilesAttachmentRequestArgs): ApiRequestDescriptor => {
  const endpoint =
    type === attachmentsListOrigins.CONTROL ? CONTROL_ENDPOINT : MYACCOUNT_ENDPOINT;

  return {
    url: endpoint.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
    config: { method: SUPPORTED_METHODS.GET },
  };
};
